import { render } from "./Button.vue?vue&type=template&id=b5a8e46c"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
script.render = render

export default script